import {IFilters} from '../pages/SRP/redux/types';

export default function transformVoyagerResultToFilter(destination, filter: IFilters = {}) {
  if (!destination || destination === null) {
    return {};
  }

  const nlquery = destination?.xtr?.flt || {};

  const newFilter = {};

  // ! can add try-catch handling for error / exceptions
  let tags = [];
  let location_search = [];
  if (nlquery) {
    if (nlquery.tg && Array.isArray(nlquery.tg)) {
      // ! come back here if filter can be used instead directly on nlquery.tg, need to know how this flow is invoked
      tags = [...nlquery.tg];
      tags.splice(tags.indexOf('Deal'), 1);
      // tags = tags.filter(item => item !== 'Deal');
    }

    if (nlquery.pbc) {
      tags.push('goStays'); // ! goStays as a text should / can be run from application-config
    }

    if (nlquery.srt) {
      newFilter.star = nlquery.srt;
    }

    if (nlquery.pt) {
      newFilter.ht = nlquery.pt;
    }

    if (nlquery.loc) {
      const destObj = {
        loc_id: nlquery.loc._id,
        n: nlquery && nlquery.loc && nlquery.loc.n ? nlquery.loc.n : '',
        id_type: 'voy',
      };
      if (nlquery.loc.mmId && nlquery.loc.mmType) {
        destObj.mmId = nlquery.loc.mmId;
        destObj.mmType = nlquery.loc.mmType;
      }
      if (destination?.crd) {
        destObj.lat = destination.crd[0];
        destObj.lng = destination.crd[1];
      }
      if (destination?.auto) {
        destObj['auto'] = 'true';
      }
      location_search.push(destObj);
    }
  }

  if (destination?.xtr?.ggl_id) {
    const destObj = {
      loc_id: destination.xtr.ggl_id,
      id_type: 'ggl_id',
      n: destination.n,
    };

    if (destination?.auto) {
      destObj['auto'] = 'true';
    }

    if (destination?.crd?.length === 2) {
      destObj['la'] = destination.crd[0];
      destObj['lo'] = destination.crd[1];
    }

    location_search.push(destObj);
  }

  if (tags && tags.length > 0) {
    newFilter.tags = [...tags];
  }

  if (location_search && location_search.length > 0) {
    newFilter.location_search = [...location_search];
  }

  return newFilter;
}
